import React, { useEffect, useState } from "react";

const PageTransition = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // enter animation
    const timeout = setTimeout(() => setIsVisible(true), 10);
    return () => {
      // exit animation
      setIsVisible(false);
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div
      className={`transition-all duration-700 ease-out transform
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
      `}
    >
      {children}
    </div>
  );
};

export default PageTransition;
